/**
 * Detection State — Sprint 16b
 *
 * Persists state between detection pipeline runs to enable
 * incremental processing and cross-source context preservation.
 */
/** Create a fresh detection state */
export function createEmptyDetectionState() {
    return {
        lastRunTimestamp: 0,
        lastRunId: '',
        sourceWatermarks: {
            email: 0,
            financial: 0,
            calendar: 0,
            browsing: 0,
        },
        entityIds: [],
        sourceSummaries: {
            email: null,
            financial: null,
            calendar: null,
            browsing: null,
        },
        cloudConsent: false,
    };
}
/**
 * Update watermark for a source after successful processing.
 */
export function updateWatermark(state, source, timestamp) {
    return {
        ...state,
        sourceWatermarks: {
            ...state.sourceWatermarks,
            [source]: timestamp,
        },
    };
}
/**
 * Store a Pass 1 summary for a source.
 */
export function storeSummary(state, source, summary, model, itemCount) {
    return {
        ...state,
        sourceSummaries: {
            ...state.sourceSummaries,
            [source]: {
                summary,
                generatedAt: Date.now(),
                model,
                itemCount,
            },
        },
    };
}
/**
 * Get sources that have stored summaries (for Pass 2 input).
 */
export function getAvailableSummaries(state) {
    const results = [];
    for (const [source, data] of Object.entries(state.sourceSummaries)) {
        if (data) {
            results.push({
                source: source,
                summary: data.summary,
                generatedAt: data.generatedAt,
                itemCount: data.itemCount,
            });
        }
    }
    return results;
}
/**
 * Check which sources have new data since their watermark.
 */
export function getSourcesWithNewData(state, latestTimestamps) {
    const sources = [];
    for (const [source, latest] of Object.entries(latestTimestamps)) {
        if (latest && latest > (state.sourceWatermarks[source] ?? 0)) {
            sources.push(source);
        }
    }
    return sources;
}
/**
 * Mark a completed run in state.
 */
export function markRunCompleted(state, runId, entityIds) {
    return {
        ...state,
        lastRunTimestamp: Date.now(),
        lastRunId: runId,
        entityIds,
    };
}
/**
 * Check if this is the first run or a migration run.
 */
export function isFirstOrMigrationRun(state, entityDetectionRunIds) {
    if (!state || state.lastRunId === '')
        return true;
    return entityDetectionRunIds.some(id => !id || id === 'migration-0');
}
//# sourceMappingURL=detection-state.js.map